<template>
  <div class="device-detail-params-content">
    <div class="device-detail-main-content-title">
      <h3>
        {{ $t('device_side_config') }}
      </h3>
      <div class="device-detail-main-content-title-right">
        <a-checkbox :checked="checkedAll" @change="onCheckAllChange" :indeterminate="indeterminate">
          {{ checkedAll ? $t('com_table_check_reverse') : $t('com_table_check_all') }}
        </a-checkbox>

        <!-- 批量设置 -->
        <a-button
          type="default"
          icon="setting"
          v-if="hasOnline() && AUTH_DEVICE_PARAM_SETS"
          @click="setParams()"
          :disabled="!checkedParamsList.length"
        >
          {{ $t('device_params_batch_set') }}
        </a-button>

        <!-- 配置日志 -->
        <a-button type="default" @click="showLogs" v-if="AUTH_DEVICE_PARAMS_CHANGE_HISTORY">
          {{ $t('device_params_logs') }}
        </a-button>

        <!-- 导出(没有权限控制，所有人都能导出) -->
        <a-tooltip
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-if="AUTH_DEVICE_PARAM_EXPORT"
        >
          <template slot="title">{{ $t('com_btn_export') }}</template>
          <a-button type="default" icon="upload" @click="exportParams"> </a-button>
        </a-tooltip>

        <!-- 导入 -->
        <a-tooltip
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-if="
            device &&
              device.info &&
              configList &&
              configList.length > 0 &&
              hasOnline() &&
              AUTH_DEVICE_PARAM_SETS
          "
        >
          <template slot="title">{{ $t('com_btn_import') }}</template>
          <a-button type="default" icon="download" @click="setParams(null, true)"> </a-button>
        </a-tooltip>
      </div>
    </div>

    <div class="device-detail-run-info-list">
      <!-- 配置分类列表 -->
      <div
        class="device-detail-main-content-action"
        v-if="currentParamsGroupList && currentParamsGroupList.length > 0"
      >
        <ul>
          <li :class="!currentGroupId ? 'active' : ''" @click="filterConfigsByModelGroup()">
            {{ $t('com_form_all') }}
          </li>
          <li
            v-for="group in this.currentParamsGroupList"
            :key="group.groupId"
            :class="group.groupId === currentGroupId ? 'active' : ''"
            @click="filterConfigsByModelGroup(group.groupId)"
          >
            {{ group.groupName }}
          </li>
          <li>
            <div>
              <!-- 101表示配置信息 -->
              <router-link
                :to="{
                  name: 'DocsDetailType',
                  params: { type: 101 },
                }"
                v-auth="['auth_docs_detail']"
              >
                <a-icon type="question-circle" />
              </router-link>
            </div>
          </li>
        </ul>
      </div>
      <!-- list -->
      <a-checkbox-group
        v-model="checkedParamsList"
        class="device-detail-main-content-card"
        @change="onCheckItemChange"
        v-if="AUTH_DEVICE_PARAMS_CONFIG"
      >
        <dl v-for="(groupItem, index) in currentParamsListByGroup" :key="index">
          <dt>{{ groupItem.groupName }}</dt>
          <dd>
            <ul>
              <li
                v-for="configItem in groupItem.groupList"
                :key="configItem.id"
                :class="deviceStatus.now - configItem.reTime > oldDataTimeRecord ? 'old-data' : ''"
              >
                <ins>
                  <a-checkbox
                    :value="configItem.id"
                    :disabled="!hasBatchEditAuth(configItem)"
                    v-if="hasBatchEditAuth(configItem)"
                  >
                    {{ configItem.name | defalutValue }}
                  </a-checkbox>
                  <a-checkbox
                    :value="configItem.id"
                    :disabled="!hasBatchEditAuth(configItem)"
                    v-else
                  />
                  <span v-if="!hasBatchEditAuth(configItem)">{{
                    configItem.name | defalutValue
                  }}</span>
                </ins>

                <!-- rflag===1为成功 -->
                <div class="g-refresh-status">
                  <Icon type="status_ok" class="success" v-if="configItem.rflag === 1" />
                  <Icon type="status_error" class="error" v-else />

                  <a-popover trigger="hover">
                    <!-- 前一次的值 -->
                    <template slot="content">
                      {{ $t('device_config_previous_value') + ' : ' }}
                      <span v-if="configItem.prevValue">
                        {{ itemTypes.calcTypeValue(configItem, configItem.prevValue, 'prevValue') }}
                        <span v-if="configItem.dataUnit">
                          {{ configItem.dataUnit }}
                        </span>
                      </span>
                      <span v-else>--</span>
                    </template>

                    <!-- 当前值 -->
                    <span
                      :class="hasSingleEditAuth(configItem) ? 'can-edit' : ''"
                      @click="setParams(configItem)"
                    >
                      {{
                        configItem.rvalue
                          ? itemTypes.calcTypeValue(configItem, configItem.rvalue, 'rvalue')
                          : '--'
                      }}
                      <span v-if="configItem.dataUnit">
                        {{ configItem.dataUnit }}
                      </span>
                    </span>
                  </a-popover>
                </div>
                <span v-if="configItem.reTime">
                  {{ configItem.reTime | formatDate }}
                </span>
                <span v-else>--</span>
              </li>
            </ul>
          </dd>
        </dl>
      </a-checkbox-group>
    </div>

    <!-- 设置 -->
    <SetParams
      ref="setParams"
      v-if="
        device &&
          device.info &&
          configList &&
          configList.length > 0 &&
          hasOnline() &&
          (AUTH_DEVICE_PARAM_SETS || AUTH_DEVICE_PARAM_SET)
      "
      :deviceInfo="device.info"
      :paramsList="configList"
      :callback="
        () => {
          this.getParamsList('refresh');
        }
      "
    />

    <!-- 导出 -->
    <ExportParams ref="exportParams" v-if="device.info && AUTH_DEVICE_PARAM_EXPORT" :data="null" />

    <!-- 配置日志 -->
    <a-modal
      :title="$t('device_params_logs')"
      v-model="logsVisible"
      width="80%"
      :footer="null"
      :centered="true"
      v-if="AUTH_DEVICE_PARAMS_CHANGE_HISTORY"
    >
      <ParamsLog :deviceId="device.info.devId" />
    </a-modal>
  </div>
</template>
<script>
import * as API from '@/api/device';
import itemTypes from '@/libs/itemTypes';
import { mapGetters } from 'vuex';
import SetParams from './components/params_set.vue';
import ExportParams from './components/export.vue';
import ParamsLog from './detail_params_log.vue';
import deviceAuth from '@/views/device/mixins/deviceAuth';

export default {
  mixins: [deviceAuth],
  components: {
    SetParams,
    ExportParams,
    ParamsLog,
  },
  props: ['device', 'deviceStatus', 'deviceStatusFn', 'allGroupList'],
  data() {
    return {
      itemTypes,

      loading: false,

      // 配置列表
      configList: null,
      // group
      currentParamsGroupList: [],
      currentGroupId: null,

      // 当前配置列表
      currentParamsList: [],
      currentParamsListByGroup: [],

      // 配置表格
      columns: [
        {
          title: '#',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: this.$t('com_form_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'Name' },
        },
        {
          title: this.$t('device_table_current_value'),
          dataIndex: 'rvalue',
          scopedSlots: { customRender: 'Value' },
        },
        {
          title: this.$t('device_table_refresh_time'),
          dataIndex: 'reTime',
          width: 150,
          scopedSlots: { customRender: 'reTime' },
        },
      ],

      checking: false,

      // list polling
      listPollingTimer: null,
      // 第一次轮询请求5秒间隔，后续15秒
      listPollingTimeFisrt: 5 * 1000,
      listPollingTime: 15 * 1000,

      oldDataTime: 30 * 1000,
      oldDataTimeRecord: 60 * 1000,

      // 编辑选择
      indeterminate: false,
      checkedAll: false,
      checkedParamsList: [],

      // 日志
      logsVisible: false,
    };
  },
  created() {
    // 权限操作(非禁用状态才可用)
    if (
      (this.authList.includes('auth_device_param_set') ||
        this.authList.includes('auth_device_param_sets') ||
        this.isSuperAdmin) &&
      !this.device.info.disable &&
      this.hasOnline()
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        align: 'center',
        scopedSlots: { customRender: 'Action' },
      });
    }

    if (this.authList.includes('auth_device_param_list')) {
      this.getParamsList();
    }
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin', 'logout']),

    rowSelection() {
      return {
        onChange: (selectedRowKeys, _selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            // 支持批量操作才允许勾选
            disabled: !record.setBatchSupport || !record.setable,
            // disabled: !record.setBatchSupport,
            name: record.name,
          },
        }),
      };
    },
  },

  beforeDestroy() {
    this.stopPolling();
  },

  methods: {
    // 是否允许批量操作
    hasBatchEditAuth(record) {
      return (
        this.hasOnline() &&
        (this.authList.includes('auth_device_param_set') || this.isSuperAdmin) &&
        record.setBatchSupport &&
        record.setable &&
        this.authList.includes('auth_device_param_list')
      );
    },

    // 允许单个编辑
    hasSingleEditAuth(record) {
      return (
        this.hasOnline() &&
        (this.authList.includes('auth_device_param_set') || this.isSuperAdmin) &&
        record.setable &&
        this.authList.includes('auth_device_param_list')
      );
    },

    // 选择某个
    onCheckItemChange() {
      // 选择了部分
      this.indeterminate =
        this.checkedParamsList.length > 0 &&
        this.checkedParamsList.length < this.currentParamsList.length;
    },

    // 全选、取消全选
    onCheckAllChange() {
      this.checkedAll = !this.checkedAll;

      if (this.checkedAll) {
        // 点的时候，选中（可以选择的）所有或取消所有选择
        const _checkedList = [];
        // 只选择当前group的
        this.currentParamsList.forEach(item => {
          if (this.hasBatchEditAuth(item)) {
            _checkedList.push(item.id);
          }
        });
        this.checkedParamsList = _checkedList;
      } else {
        this.checkedParamsList = [];
      }

      this.indeterminate = false;
    },

    // 在线判断
    hasOnline() {
      return (
        this.device &&
        this.deviceStatus &&
        this.deviceStatus.info &&
        this.deviceStatus.info.onlineStatus === 1 &&
        !this.deviceStatus.info.disable
      );
    },

    // 获取配置项
    getParamsList(type, firstPolling) {
      const params = {
        devId: this.device.info.devId,
      };
      const isPolling = type === 'polling' || firstPolling;
      const isRefresh = type === 'refresh';

      if (!isPolling && !isRefresh) {
        this.loading = true;
      }

      return API.DeviceParamsList(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            // 配置
            this.configList = res.data.params || [];
            this.$emit('getParamsList', this.configList);
            // 计算当前配置的分类
            const _groupList = [];
            const groupIds = Array.from(new Set(this.configList.map(item => item.groupId)));
            if (this.allGroupList && this.allGroupList.length) {
              this.allGroupList.forEach(item => {
                if (groupIds.includes(item.groupId)) {
                  _groupList.push(item);
                }
              });
            }
            this.currentParamsGroupList = _groupList;

            // 默认所有
            if (isPolling || isRefresh) {
              this.filterConfigsByModelGroup('polling');
            } else {
              this.filterConfigsByModelGroup();
            }
          }
        })
        .finally(() => {
          this.loading = false;

          // 第一次轮询调用list结束，更新父级刷新按钮状态
          if (firstPolling) {
            this.$parent.firstRefreshLoading = false;
          }
          // 刷新结束
          if (isRefresh) {
            this.$parent.refreshLoading = false;
          }

          // 15秒轮询1次
          this.stopPolling();

          // 没有退出登录时才轮询
          if (!this.logout) {
            const self = this;
            this.listPollingTimer = setTimeout(function() {
              self.getParamsList('polling', self.listPollingTimeFisrt);
              self.listPollingTimeFisrt = null;
            }, this.listPollingTimeFisrt || this.listPollingTime);
          }
        });
    },

    // 停止轮询
    stopPolling() {
      if (this.listPollingTimer) {
        clearTimeout(this.listPollingTimer);
      }
    },

    // 过滤
    filterConfigsByModelGroup(groupId) {
      if (groupId !== 'polling') {
        this.currentGroupId = groupId;

        // 非polling清空选择
        this.checkedAll = false;
        this.checkedParamsList = [];
        this.indeterminate = false;
        //--end
      }

      let filterConfigList = [];

      if (!this.currentGroupId) {
        filterConfigList = this.configList;
      } else {
        filterConfigList = this.configList
          ? this.configList.filter(item => item.groupId === this.currentGroupId)
          : [];
      }

      this.currentParamsList = filterConfigList;

      // 按group重新组合数据，同一个groupId的数据放在一起
      let _list = [];
      this.allGroupList.forEach(group => {
        const _group = filterConfigList.filter(item => item.groupId === group.groupId);
        if (_group.length) {
          _list.push({
            groupName: group.groupName,
            groupList: _group,
            len: _group.length,
          });
        }
      });

      // 按len从少到多排序
      _list = _list.sort((a, b) => a.len - b.len);

      this.currentParamsListByGroup = _list;
    },

    // 设置参数
    setParams(record, upload) {
      if (record) {
        if (!this.hasSingleEditAuth(record)) {
          return;
        }
      }

      let selectedParams = [];
      if (upload) {
        // 上传传入this.configList做为参数，只是为了获取当前设备允许的配置项（非项目中的配置不允许通过上传设置）
        this.$refs.setParams.show(this.configList, upload);
      } else {
        if (record) {
          selectedParams = [record];
        } else {
          if (!(this.checkedParamsList && this.checkedParamsList.length)) {
            this.$message.error(this.$t('com_msg_select_params_first'));
            return;
          }
          selectedParams = this.configList.filter(item => {
            return this.checkedParamsList.includes(item.id);
          });
        }
        this.$refs.setParams.show(selectedParams, false);
      }
    },

    // 导出
    exportParams() {
      if (!(this.checkedParamsList && this.checkedParamsList.length)) {
        this.$confirm({
          title: this.$t('device_export_params_all'),
          centered: true,
          maskClosable: true,
          onOk: () => {
            this.$refs.exportParams.show(this.device.info, this.configList);
          },
        });

        // this.$message.error(this.$t('com_msg_select_params_first'));
        return;
      }

      let selectedParams = [];
      selectedParams = this.configList.filter(item => {
        return this.checkedParamsList.includes(item.id);
      });
      this.$refs.exportParams.show(this.device.info, selectedParams);
    },

    // 日志
    showLogs() {
      this.logsVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.detail-remote {
  padding-bottom: 50px;
}
.device-params-refresh {
  padding: 0 !important;
  margin: 0 !important;
  width: auto !important;
  display: flex !important;
  justify-content: space-between !important;
  h3 {
    padding: 5px;
    font-size: 14px;
    font-weight: bold;
    color: #666;
    margin: 0;
  }
}

.device-params-btn {
  border-top: #eee solid 1px;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
}

::v-deep .device-config-list {
  // 不支持批量操作的，不可以选择
  .ant-checkbox-disabled {
    .ant-checkbox-inner {
      background: #f0f0f0 !important;
      border-color: #f0f0f0 !important;
    }
  }
}
</style>
